import React, { useState } from 'react';
import { sendLog } from 'mypages-library';
import { trackEvent } from 'common/google/util';
import { fetchWithFailover } from 'default-client/DefaultClient';
import { t } from 'i18n/translate';
import ForgotPasswordMailSent from './ForgotPasswordMailSent';
import ForgotPasswordEnterEmail from './ForgotPasswordEnterEmail';

interface Violation {
  type: string;
  name: string;
  message: string;
}

// TODO metrics and logs
const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [apiErrorMessage, setApiErrorMessage] = useState('');

  const isSuccessfulValidation = (response: Response | undefined) => response?.ok && response?.status === 204;
  const handleError = async (response: Response | undefined, emailAddress: string) => {
    if (response?.status === 429) {
      setApiErrorMessage(t('MPL_TOO_MANY_TOKEN_REQUESTS_ATTEMPTED'));
      return;
    }
    if (response?.status === 400) {
      try {
        const errorData = await response.json();
        // if we get a email constraint violation error, we want to log it because our frontend validation should prevent this
        if (
          errorData.type?.includes('constraint-violation') &&
          errorData.violations?.some((v: Violation) => v.name === 'forgotPassword.email')
        ) {
          const emailViolation = errorData.violations.find((v: Violation) => v.name === 'forgotPassword.email');
          if (emailViolation) {
            sendLog('emailValidationError', { invalidEmail: emailAddress }, { invalidEmail: emailAddress });
          }
        }
      } catch (e) {
        setApiErrorMessage(t('MPL_ETC_ERROR_OCCURED_TRY_AGAIN'));
      }
    }
    setApiErrorMessage(t('MPL_ETC_ERROR_OCCURED_TRY_AGAIN'));
  };
  const sendEmail = async (emailAddress: string, reCaptchaResponse: string) => {
    try {
      const verifyAccountResponse = await fetchWithFailover(`/webaccount/public/${emailAddress}/password/forgot`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          APPLICATION_ID: process.env.REACT_APP_APPLICATION_ID,
        },
        body: JSON.stringify({ reCaptchaResponse }),
      });

      const success = isSuccessfulValidation(verifyAccountResponse);
      if (!success) {
        // should only be able to fail at badly formatted email, invalid captcha or too many requests
        handleError(verifyAccountResponse, emailAddress);
      } else {
        trackEvent({
          eventCategory: 'Forgot password',
          eventAction: 'Password reset email sent',
          eventValue: 'success',
        });
      }
      return Promise.resolve(success);
    } catch (e) {
      return Promise.resolve(false);
    }
  };

  const onEmailEntered = async (emailAddress: string, recaptchaResponse: string) => {
    const success = await sendEmail(emailAddress, recaptchaResponse);
    if (success) {
      setEmail(emailAddress);
    }
  };

  if (email.length > 0) {
    return <ForgotPasswordMailSent email={email} />;
  }
  return (
    <ForgotPasswordEnterEmail
      onValidEmailEntered={onEmailEntered}
      apiErrorMessage={apiErrorMessage}
      setApiErrorMessage={setApiErrorMessage}
    />
  );
};
export default ForgotPassword;
